import ReturnManagerFieldGroup from './components/returnManagerFieldGroup/returnManagerFieldGroup';
import ManagerFieldGroup from './components/managerFieldGroup/managerFieldGroup';

const ManagerFieldGroups = () => {
  return (
    <div className="flex flex-col gap-[92px]">
      {/* 브랜드 담당자 정보 */}
      <ManagerFieldGroup />

      {/* 반품 담당자 정보 */}
      <ReturnManagerFieldGroup />
    </div>
  );
};

export default ManagerFieldGroups;
